<template>
  <div class="template-detail">
    <div class="detail-header">
      <div class="template-operations pull-right">
        <Button type="primary" ghost
          v-if="checkRolePermitted(['总监管人','管理员'])&&templateModel.needAudit"
          @click="auditPass">
          <Icon type="md-create" />
          审核通过</Button>
        <Button type="error" ghost
          v-if="checkRolePermitted(['总监管人','管理员'])&&!templateModel.needAudit"
          @click="auditDeny">
          <Icon type="md-create" />
          审核不通过</Button>
      </div>
      <h2>
        {{templateModel.name}}
        <Tag v-if="templateModel"
          :color="!templateModel.needAudit?'success':'error'">
          {{!templateModel.needAudit?'已审核':'未审核'}}
        </Tag>
      </h2>
      <div class="font-grey small">创建时间:{{require('moment')(templateModel.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
    </div>
    <div class="detail-body">
      <table class="brief-table">
        <tbody>
          <tr>
            <td class="title">保证人名称</td>
            <td>{{templateModel.guarantorName}}</td>
            <td class="title">审核状态</td>
            <td>{{!templateModel.needAudit?'已审核':'未审核'}}</td>
            <td class="title">公共模板</td>
            <td>{{templateModel.isPrivate?'私有':'公共'}}</td>
          </tr>
          <tr>
            <td class="title">适用行业</td>
            <td>{{templateModel.industryName||'全部'}}</td>
            <td class="title">适用种类</td>
            <td>{{templateModel.varietyName}}</td>
            <td class="title">适用区域</td>
            <td>{{templateModel.cityName||'全部'}}</td>
          </tr>
        </tbody>
      </table>
      <div class="padding-top-20"></div>
      <Tabs type="card" class="tab-square" :animated="false">
        <TabPane label="预览" name="preview">
          <iframe width="100%" height="600" frameborder="0" id="tplPreview"></iframe>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'template-detail',
  props: {
  },
  data () {
    return {
      loading: false,
      curTab: '',
      templateModel: {
        id: null,
        name: null,
        type: null,
        template: null,
        guarantorId: null,
        guarantorName: null,
        variety: null,
        varietyName: null,
        industryId: null,
        industryName: null,
        cityId: null,
        cityName: null,
        isPrivate: null,
        needAudit: null,
        createTime: null,
        updateTime: null
      }
    }
  },
  watch: {
    '$route.params.templateId': function () {
      this.getTemplateDetail()
    }
  },
  mounted () {
    this.getTemplateDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    getTemplateDetail () {
      Api.GuaranteeTemplate.getGuaranteeTemplateDetail(this.$route.params.templateId).then((res) => {
        Object.assign(this.templateModel, res)
        document.getElementById('tplPreview').contentWindow.document.write(this.templateModel.template)
        document.getElementById('tplPreview').contentWindow.document.close()
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    auditPass () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认审核通过么？</p>',
        onOk: async () => {
          this.$Spin.show()
          await this.$Api.GuaranteeTemplate.auditPassGuaranteeTemplate(this.$route.params.templateId)
          .then(() => {
            // console.log(payload)
            this.$Message.success('操作成功!')
            this.$Spin.hide()
            this.getTemplateDetail()
          })
          .catch(err => {
            this.$Spin.hide()
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
          })
        }
      })
    },
    auditDeny () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认审核不通过么？</p>',
        onOk: async () => {
          this.$Spin.show()
          await this.$Api.GuaranteeTemplate.auditDenyGuaranteeTemplate(this.$route.params.templateId)
          .then(() => {
            // console.log(payload)
            this.$Message.success('操作成功!')
            this.$Spin.hide()
            this.getTemplateDetail()
          })
          .catch(err => {
            this.$Spin.hide()
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-header {
  margin-bottom: 20px;
}
</style>
